/** Must match API `buildOwnershipMessage` in clientWalletService.ts */
export function buildOwnershipMessage(address: string, provider: string): string {
  return `Verify CWY wallet ownership: ${address} provider:${provider} at ${Date.now()}`;
}
